import { render, staticRenderFns } from "./Makers.vue?vue&type=template&id=74d6a6ec&"
import script from "./Makers.vue?vue&type=script&lang=js&"
export * from "./Makers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d6a6ec')) {
      api.createRecord('74d6a6ec', component.options)
    } else {
      api.reload('74d6a6ec', component.options)
    }
    module.hot.accept("./Makers.vue?vue&type=template&id=74d6a6ec&", function () {
      api.rerender('74d6a6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Makers.vue"
export default component.exports